// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2drib","controls":"styles_controls__1ktg-","charLimit":"styles_charLimit__lJ67k","input":"styles_input__3Eejm","send":"styles_send__2QRmF"};